export default {
  Auth: {
    userPoolId: 'ap-southeast-1_tzgTFwvYQ',
    userPoolWebClientId: '7vs9ttsh69ierrq5v9k0rom5sf',
    region: 'ap-southeast-1'
  },
  AppSync: {
    aws_appsync_graphqlEndpoint: 'https://nlauncher.nedigital.sg/graphql',
    aws_appsync_region: 'ap-southeast-1',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    aws_appsync_apiKey: 'null'
  }
};
